export const GET_LIST_OF_CONTACTS =
  'src/modules/sidebar/GET_LIST_OF_CONTACTS';
export const LOAD_MORE_CONTACS =
  'src/modules/sidebar/LOAD_MORE_CONTACS';
export const CANCEL_ALL_API_REQUESTS =
  'src/modules/sidebar/CANCEL_ALL_API_REQUESTS';
